<div class="relative">

    <!-- TRIGGER BUTTON -->
    <button type="button" (click)="toggle()"
        class="flex h-11 w-full items-center justify-between rounded-lg border bg-transparent px-3.5 text-sm shadow-theme-xs transition-colors focus:outline-none focus:ring-3"
        [ngClass]="disabled
            ? 'cursor-default border-gray-200 text-gray-500 opacity-70 dark:border-gray-700 dark:text-gray-500'
            : 'cursor-pointer border-gray-300 text-gray-800 hover:border-gray-400 focus:border-brand-300 focus:ring-brand-500/10 dark:border-gray-700 dark:text-white/90 dark:focus:border-brand-800'"
        [disabled]="disabled">

        <span class="truncate text-left"
            [ngClass]="value ? '' : 'text-gray-400 dark:text-white/30'">
            {{ value ? selectedLabel : placeholder }}
        </span>

        <span class="ml-2 flex shrink-0 items-center gap-1">
            @if (value && !disabled) {
            <span (click)="clear($event)"
                class="flex h-4 w-4 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-700 dark:hover:text-gray-200">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" class="h-3 w-3">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </span>
            }
            <svg viewBox="0 0 20 20" fill="currentColor"
                class="h-4 w-4 text-gray-400 transition-transform duration-150"
                [ngClass]="isOpen ? 'rotate-180' : ''">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
            </svg>
        </span>
    </button>

    <!-- DROPDOWN PANEL -->
    @if (isOpen) {
    <div
        class="absolute left-0 z-50 mt-1 w-full min-w-[280px] rounded-xl border border-gray-200 bg-white shadow-xl dark:border-gray-700 dark:bg-gray-900">

        <!-- SEARCH INPUT -->
        <div class="border-b border-gray-100 p-2 dark:border-gray-700">
            <div class="relative">
                <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <svg class="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                </div>
                <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()"
                    placeholder="Buscar por código, dpto., prov. o distrito..."
                    class="w-full rounded-lg border border-gray-200 bg-gray-50 py-2 pl-9 pr-3 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder:text-gray-500"
                    autofocus />
            </div>
        </div>

        <!-- RESULTS LIST -->
        <div class="max-h-56 overflow-y-auto">

            @if (loading) {
            <div class="flex items-center justify-center gap-2 py-8 text-sm text-gray-400">
                <svg class="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                Cargando ubigeos...
            </div>
            } @else if (filtered.length === 0) {
            <div class="py-8 text-center text-sm text-gray-400">Sin resultados</div>
            } @else {
            @for (u of displayed; track u.ubigeo) {
            <button type="button" (click)="select(u)"
                class="flex w-full items-center gap-3 px-4 py-2.5 text-left text-sm transition-colors hover:bg-gray-50 dark:hover:bg-gray-800"
                [ngClass]="u.ubigeo === value ? 'bg-brand-50 dark:bg-brand-900/20' : ''">
                <span class="w-14 shrink-0 font-mono text-xs text-gray-400">{{ u.ubigeo }}</span>
                <span class="truncate text-gray-700 dark:text-gray-300">
                    {{ u.department }} / {{ u.province }} / {{ u.district }}
                </span>
                @if (u.ubigeo === value) {
                <svg class="ml-auto h-4 w-4 shrink-0 text-brand-500" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                }
            </button>
            }

            @if (hiddenCount > 0) {
            <div
                class="border-t border-gray-100 px-4 py-2 text-center text-xs text-gray-400 dark:border-gray-700">
                {{ hiddenCount }} resultado{{ hiddenCount !== 1 ? 's' : '' }} más — escribe para filtrar
            </div>
            }
            }

        </div>

    </div>
    }

</div>
